<template>
  <div class="z-card">
    <h2>{{ $t('tasks.campaign.form.card.title') }}</h2>
    <table class="table">
      <thead>
        <tr>
          <th>{{ $t('shared.cart.name') }}</th>
          <th>{{ $t('shared.cart.price') }}</th>
          <th>{{ $t('shared.cart.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in items" :key="i">
          <th scope="row">
            <v-text-field v-model="item.name" outlined dense />
          </th>
          <th scope="row">
            <v-text-field v-model="item.cost" outlined dense />
          </th>
          <th scope="row">
            <v-text-field v-model="item.quantity" outlined dense />
          </th>
          <th class="align-middle">
            <v-icon color="#000" @click="remove(i)"> mdi-close </v-icon>
            <!-- <icon type="ios-close-circle-outline" size="24" class="mt-2" @click="remove(i)" />  -->
          </th>
        </tr>
        <v-icon class="mt-4" color="#000" @click="add_item"> mdi-plus </v-icon>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      is_edit: {
        type: Boolean,
        default: false
      },

      cart_items: {
        type: [Array, String],
        default: () => []
      }
    },

    data: () => ({
      items: []
    }),

    watch: {
      cart_items: {
        handler: function (val) {
          if (this.is_edit) this.items = val ? val : [];
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      add_item() {
        this.items.push({
          name: '',
          cost: '',
          quantity: ''
        });
      },
      returnItems() {
        this.$emit('cart_items', this.items);
      },
      remove(i) {
        this.items.splice(i, 1);
        this.$emit('cart_items', this.items);
      }
    }
  };
</script>

<style></style>
